import api from './api';

const costVariationsService = {
  // Buscar variações de um custo
  getCostVariations: async (costId) => {
    try {
      const response = await api.get(`/cost-variations/cost/${costId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar variações:', error);
      throw error;
    }
  },

  // Criar nova variação
  createVariation: async (costId, variationData) => {
    try {
      const response = await api.post(`/cost-variations/cost/${costId}`, variationData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar variação:', error);
      throw error;
    }
  },

  // Atualizar variação
  updateVariation: async (variationId, variationData) => {
    try {
      const response = await api.put(`/cost-variations/${variationId}`, variationData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar variação:', error);
      throw error;
    }
  },

  // Deletar variação
  deleteVariation: async (variationId) => {
    try {
      const response = await api.delete(`/cost-variations/${variationId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar variação:', error);
      throw error;
    }
  },

  // Calcular preço com variações
  calculatePrice: async (costId, calculationData) => {
    try {
      const response = await api.post(`/cost-variations/calculate/${costId}`, calculationData);
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular preço:', error);
      throw error;
    }
  },

  // Buscar regras de cálculo
  getCalculationRules: async () => {
    try {
      const response = await api.get('/cost-variations/rules');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar regras:', error);
      throw error;
    }
  },

  // Atualizar regra de cálculo
  updateCalculationRule: async (ruleId, ruleData) => {
    try {
      const response = await api.put(`/cost-variations/rules/${ruleId}`, ruleData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar regra:', error);
      throw error;
    }
  }
};

export default costVariationsService;
